// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__bv16B","insideContainer":"Footer_insideContainer__m+Y3k","header":"Footer_header__2x+V4","pTag":"Footer_pTag__got7e","buttons":"Footer_buttons__U8cs5"};